import './ReimbursementDetailsFrame.css';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { WEB_VIEW_TYPES } from '../../../../constants';
import { useWebviewMultibrand } from '../../../../hooks';
import FigoLottie from '../../../common/FigoLottie';
import { NeedToUpdateScreen } from '../../NeedToUpdateScreen';

export const ReimbursementDetailsFrame = ({
  petId = '',
  policy = {},
}) => {
  const { t } = useTranslation('myAccount');

  const {
    getWebView,
    isLoading,
    title,
    url,
    error,
  } = useWebviewMultibrand();
  const {
    marketingChannelId,
    policyId,
    policyNumber,
    coveragePeriodId,
  } = policy;

  useEffect(() => {
    const params = {
      companyId: marketingChannelId,
      coveragePeriodId,
      petId,
      policyId,
      policyNumber,
      webViewType: WEB_VIEW_TYPES.reimbursementMethod,
    };

    if (getWebView) {
      getWebView(params);
    }
  }, [
    coveragePeriodId,
    getWebView,
    marketingChannelId,
    petId,
    policyId,
    policyNumber,
  ]);

  if (!isLoading && error) {
    return (
      <NeedToUpdateScreen
        descriptionI18nKey="ppu.reimbursement.description"
        header={t('reimbursementCard.title')}
        title={t('ppu.reimbursement.title')}
      />
    );
  }

  return (
    <div
      className={`Reimbursement-details__container 
      Colors-${marketingChannelId}`}
    >
      <div className="Reimbursement-details__page-title">
        <h1>{t('reimbursementSection.policyDetails')}</h1>
      </div>

      <div className="Reimbursement-details__iframe">
        {isLoading && <FigoLottie />}

        {!isLoading && !error && (
          <iframe
            allowFullScreen
            src={url}
            title={title}
          />
        )}

        {!isLoading && error && <h3>{error}</h3>}
      </div>
    </div>
  );
};
